import React from "react";
import { Reveal, SectionLabel } from "@/components/ui-bits";
import PricingCards from "@/components/PricingCards";

const FAQ = [
  { q: "Can I switch plans anytime?", a: "Yes — upgrade, downgrade or cancel whenever you like. Changes apply immediately." },
  { q: "Is there a free plan?", a: "Absolutely. The Free plan gives you a Career Profile, daily job matches and a basic ATS score forever." },
  { q: "What does Career Max add?", a: "Face-to-face interview practice, the full Career Intelligence roadmap, and priority recruiter visibility." },
];

export default function Pricing() {
  return (
    <div className="cv-container py-20 sm:py-28">
      <Reveal className="mb-14 max-w-2xl">
        <div className="mb-4"><SectionLabel color="text-electric">Pricing</SectionLabel></div>
        <h1 className="font-heading text-4xl font-black tracking-tight sm:text-5xl">Plans that evolve with you.</h1>
        <p className="mt-4 text-lg text-muted-foreground">Start free. Upgrade when your career demands more firepower.</p>
      </Reveal>

      <PricingCards />

      <Reveal delay={0.15}>
        <div className="mx-auto mt-20 max-w-3xl">
          <h2 className="mb-6 font-heading text-2xl font-extrabold">Frequently asked</h2>
          <div className="space-y-3">
            {FAQ.map((f) => (
              <div key={f.q} className="card-surface p-5">
                <p className="font-heading font-bold">{f.q}</p>
                <p className="mt-2 text-sm text-muted-foreground">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  );
}
